import { computed } from "vue";
import { useDisplay } from "vuetify";

// Width decides layout, device decides lockdown.
// isMobile (<960px) drives layout only: mobile nav, table→card transforms, stacking.
// isReadOnlyDevice gates interaction lockdown (read-only banners, disabled fields,
// hidden action bars): it additionally requires a coarse primary pointer, so a
// narrowed desktop window gets the stacked layout but stays fully editable, while
// real phones/tablets stay view-only. Pointer capability is static per session.
const hasCoarsePointer =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(pointer: coarse)").matches;

export function useResponsive() {
  const display = useDisplay();
  const isMobile = computed(() => display.smAndDown.value); // <960
  return {
    display,
    isPhone: computed(() => display.xs.value), // <600
    isTablet: computed(() => display.sm.value), // 600–960
    isMobile,
    isDesktop: computed(() => display.mdAndUp.value), // >=960
    isReadOnlyDevice: computed(() => isMobile.value && hasCoarsePointer),
  };
}
